import React from 'react';

// Public (no login required) account-deletion instructions page.
// Required by Google Play / Apple: a publicly reachable URL explaining how
// users can request deletion of their account and associated data.
export default function DeleteAccountPage() {
  const h2 = { fontSize: '1.05rem', fontWeight: 700, margin: '24px 0 8px' };
  const p = { lineHeight: 1.7, margin: 0 };
  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', color: '#EDEDED', padding: '40px 20px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{ fontSize: '1.6rem', fontWeight: 800, marginBottom: 6 }}>
          Delete your <span style={{ color: '#FF6200' }}>Team Breakthrough</span> account
        </h1>
        <p style={{ color: '#9A9A9A', fontSize: '0.95rem', ...p }}>
          Team Breakthrough is operated by Oxygen Therapy South West Ltd. You can delete your
          account and personal data at any time using either method below.
        </p>

        <h2 style={h2}>Delete in the app</h2>
        <ol style={{ paddingLeft: 20, lineHeight: 1.7, margin: 0 }}>
          <li>Open the Team Breakthrough app and log in</li>
          <li>Go to <strong>Profile</strong></li>
          <li>Tap <strong>Delete My Account</strong> and confirm</li>
        </ol>

        <h2 style={h2}>Or request by email</h2>
        <p style={p}>
          If you can&apos;t access the app, email{' '}
          <a href="mailto:info@breakthroughgym.co.uk" style={{ color: '#FF6200' }}>
            info@breakthroughgym.co.uk
          </a>{' '}
          from your registered email address with the subject &quot;Delete my account&quot;. We will
          action your request within 30 days.
        </p>

        <h2 style={h2}>What gets deleted</h2>
        <p style={p}>
          Your account, profile information (name, email, date of birth), bookings, points/wallet
          balance and push-notification settings are permanently removed.
        </p>

        <h2 style={h2}>What we may keep</h2>
        <p style={p}>
          Purchase and transaction records may be retained for up to 6 years where required by law
          for tax and accounting purposes. These are stored securely and not used for any other
          purpose.
        </p>

        <p style={{ color: '#6A6A6A', fontSize: '0.8rem', marginTop: 36 }}>
          Team Breakthrough · Oxygen Therapy South West Ltd · Corsham, SN13 8EW
        </p>
      </div>
    </div>
  );
}
